import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DashbordRes } from '@classes/dashboard/dashboard';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getContainerDashboard(): Observable<DashbordRes> {
    return this.http.get<DashbordRes>(`${environment.apiUrl}/dashboard`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    });
  }

}
